export default "__VITE_ASSET__VyPM_f9w__"